/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import LayerStyle from './LayerStyle';
import Indicator from './Indicator';

export default class LayerIndicators {
    indicators: Indicator[] = [];



    constructor(input: any = null) {
      if (input) {

        input.indicators.forEach((styleRule: any) => {
          this.indicators.push(new Indicator(styleRule));
        });
      }
     
    }

  

    toJson():any {
      return {
        indicators: this.indicators.map((x) => x.toJson()),
      };
    }

    isDefined():any {
      return this.indicators.length > 0;
    }
}
